module.exports = __webpack_public_path__ + "static/media/ic-search.8a48b668.svg";